if (!customElements.get("drawer-slider")) {
	customElements.define(
		"drawer-slider",
		class DrawerSlider extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.swiper = this.querySelector(".swiper");
				this.swiperOptions = JSON.parse(this.dataset.sliderOptions);

				if (this.dataset.navigation) {
					this.swiperOptions.navigation = {
						prevEl: this.querySelector(".drawer-slider__prev"),
						nextEl: this.querySelector(".drawer-slider__next"),
					};
				}

				const swiper = new Swiper(this.swiper, this.swiperOptions);
			}
		}
	);
}
